import React, { FC } from "react";
import { OidcLogin } from "./oidc/OidcLogin";

export const Login: FC = () => {
  return <OidcLogin />;
};
